import {configureStore} from '@reduxjs/toolkit';
import attributesTableReducer from './Dashboard/AttributesTableComponent/attributesTableComponentSlice';
import comparisonReducer from './Dashboard/ComparisonComponent/comparisonComponentSlice';
import distributionReducer from './Dashboard/DistributionComponent/distributionComponentSlice';
import trendComponentReducer from './Dashboard/TrendComponent/trendComponentSlice';
import filtersReducer from './filters/filtersSlice';

export const store = configureStore({
  reducer: {
    filters: filtersReducer,
    attributesTable: attributesTableReducer,
    trendComponent: trendComponentReducer,
    distributionComponent: distributionReducer,
    comparisonComponent: comparisonReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
